import type { JSX } from "solid-js";
import { cn } from "./utils/cn";

const SIZE = {
  xsmall: "size-3 border-[1.5px]",
  small: "size-4 border-2",
  medium: "size-6 border-2",
  large: "size-8 border-[3px]",
} as const;

export type SpinnerSize = keyof typeof SIZE;

/** Indeterminate activity. For content that is loading, prefer a Skeleton. */
export function Spinner(props: { size?: SpinnerSize; class?: string; label?: string }): JSX.Element {
  return (
    <span
      role="status"
      aria-label={props.label ?? "Loading"}
      class={cn(
        "inline-block animate-spin rounded-full",
        "border-[color:var(--c9-border)] border-t-[color:var(--c9-text-subtle)]",
        SIZE[props.size ?? "medium"],
        props.class,
      )}
    />
  );
}
